import Favo from 'assets/icons/favo';
import { EtapaProjeto, StatusEtapa } from 'models/projeto';
import { useMemo } from 'react';
import { getMergedClassNames } from 'utils/HTMLUtils';
import languageValues from 'utils/LanguageUtils';
import styles from './step.scss';
const { rootClassName } = styles;
interface Props {
  id: EtapaProjeto;
  flgInfantil: boolean;
  status?: StatusEtapa;
  icon?: JSX.Element;
  disabled?: boolean;
  active?: boolean;
  onClick: () => void;
}

const language = languageValues.pages.projetos.etapas;
export default function Step(props: Props) {
  const text = useMemo(() => {
    const item = language[props.id].name;
    if (typeof item === 'function') {
      return item(props.flgInfantil);
    }
    return item;
  }, [props.flgInfantil, props.id]);

  return (
    <button
      onClick={props.onClick}
      className={getMergedClassNames([
        rootClassName,
        props.active ? 'active' : '',
        `status-${props.status}`,
      ])}
      disabled={props.disabled}
    >
      <Favo />
      <div className={`${rootClassName}-icon`}>{props.icon}</div>
      <div className={`${rootClassName}-tooltip`}>{text}</div>
    </button>
  );
}
